import { CartDrawer } from 'theme';

class CartDrawerWithTerms extends CartDrawer {
  constructor() {
    super(...arguments);
    
    this.initializeElements();
    this.bindMethods();
    
    this.addEventListener('cart-drawer:refreshed', this.handleCartRefresh);
  }

  initializeElements() {
    this.termsCheckbox = this.querySelector('#terms');
    this.checkoutButton = this.querySelector('button[data-checkout]');
    this.acceptTermsElement = this.querySelector('#accept-terms-element');
    this.acceptButton = this.acceptTermsElement?.querySelector('[name="accept-terms"]');
    this.declineButton = this.acceptTermsElement?.querySelector('[name="decline-terms"]');
    this.isTermsDrawerOpen = false;
  }

  bindMethods() {
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.handleEscapeKey = this.handleEscapeKey.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleAcceptTerms = this.handleAcceptTerms.bind(this);
    this.handleDeclineTerms = this.handleDeclineTerms.bind(this);
    this.handleCartRefresh = this.handleCartRefresh.bind(this);
  }

  handleCartRefresh() {
    this.removeEventListeners();
    this.initializeElements();
    this.addEventListeners();
  }

  addEventListeners() {
    if (this.termsCheckbox) {
      this.termsCheckbox.addEventListener('change', this.handleCheckboxChange);
    }
    
    if (this.checkoutButton) {
      this.checkoutButton.addEventListener('click', this.handleSubmit);
    }
    
    if (this.acceptButton) {
      this.acceptButton.addEventListener('click', this.handleAcceptTerms);
    }
    
    if (this.declineButton) {
      this.declineButton.addEventListener('click', this.handleDeclineTerms);
    }
    
    document.addEventListener('click', this.handleOutsideClick);
    document.addEventListener('keydown', this.handleEscapeKey);
  }

  removeEventListeners() {
    if (this.termsCheckbox) {
      this.termsCheckbox.removeEventListener('change', this.handleCheckboxChange);
    }
    
    if (this.checkoutButton) {
      this.checkoutButton.removeEventListener('click', this.handleSubmit);
    }
    
    if (this.acceptButton) {
      this.acceptButton.removeEventListener('click', this.handleAcceptTerms);
    }
    
    if (this.declineButton) {
      this.declineButton.removeEventListener('click', this.handleDeclineTerms);
    }
    
    document.removeEventListener('click', this.handleOutsideClick);
    document.removeEventListener('keydown', this.handleEscapeKey);
  }

  connectedCallback() {
    super.connectedCallback();
    this.addEventListeners();
  }
  
  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListeners();
  }

  handleCheckboxChange(event) {
    const checked = event.target.checked;
    this.setButtonType(checked);
    this.setButtonName(checked);
  }
  
  setButtonType(termsAccepted) {
    if (this.checkoutButton) {
      this.checkoutButton.type = termsAccepted ? 'submit' : 'button';
    }
  }
  
  setButtonName(termsAccepted) {
    if (this.checkoutButton) {
      this.checkoutButton.name = termsAccepted ? 'checkout' : 'terms';
    }
  }
  
  handleSubmit(event) {
    if (this.termsCheckbox && !this.termsCheckbox.checked) {
      event.preventDefault();
      this.showTermsElement();
    }
  }
  
  handleAcceptTerms(event) {
    event.preventDefault();
    event.stopPropagation();

    if (this.termsCheckbox) {
      this.termsCheckbox.checked = true;
      this.setButtonType(true);
      this.setButtonName(true);
    }
    
    this.hideTermsElement();
    
    if (this.checkoutButton) {
      this.checkoutButton.click();
    }
  }

  handleDeclineTerms(event) {
    event.preventDefault();
    event.stopPropagation();

    this.hideTermsElement();
  }

  handleOutsideClick(event) {
    if (this.isTermsDrawerOpen && 
      this.acceptTermsElement && 
      !this.acceptTermsElement.contains(event.target) &&
      !event.target.closest('button[data-checkout]')) {
      this.hideTermsElement();
    }
  }

  handleEscapeKey(event) {
    if (event.key === 'Escape' && this.isTermsDrawerOpen) {
      this.hideTermsElement();
    }
  }

  showTermsElement() {
    if (this.acceptTermsElement) {
      document.body.classList.add('terms-is-open');
      this.isTermsDrawerOpen = true;
            
      document.addEventListener('click', this.handleOutsideClick);
    }
  }

  hideTermsElement() {
    if (this.acceptTermsElement) {
      document.body.classList.add('terms-is-closing');
      this.isTermsDrawerOpen = false;
      document.removeEventListener('click', this.handleOutsideClick);
            
      setTimeout(() => {
        document.body.classList.remove('terms-is-open');
        document.body.classList.remove('terms-is-closing');
      }, 300);
    }
  }
}

customElements.define('cart-drawer-with-terms', CartDrawerWithTerms);